import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import history from "./components/history";
import App from "./components/App";
import "tailwindcss/dist/tailwind.css";
history.listen((location, action) => {
  window.scrollTo(0, 0);
});
ReactDOM.render(
  <Router history={history}>
    <App />
  </Router>,
  document.getElementById("root")
);
